import React, {Component} from 'react';
import '../style/table.css'
import TableRow from "./tableRow";
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/disable-selection';
import 'floatthead'
import ReactDOM from 'react-dom';

class Table extends Component {
    componentDidMount() {
        $('#tableSticky').floatThead({position: 'absolute'});

        $('#tableSticky').sortable({
            cursor: 'move',
            items: 'tbody',
            handle: "tr > td:first-child",
            helper: function(e, ui) {
                ui.children().each(function() {
                    $(this).width($(this).width());
                });
                return ui;
            },
            update: (event, ui) => {
                let orderOdIds = [];
                let movedItemGroupId =parseInt(ui.item[0].id);
                let movedItemOffset;
                $("#tableSticky > tbody").each((index, e) => {
                    orderOdIds.push(parseInt($(e).attr('id')));
                });

                //calculation of the offset in the list of the moved item
                for(let i = 0 ; i < orderOdIds.length; i++){
                    if(orderOdIds[i] === movedItemGroupId)
                        movedItemOffset = i + 1;
                }
                this.props.requestPatchPolicyQuestionsGroup(movedItemOffset, movedItemGroupId)
            },
            forcePlaceholderSize: true,
            placeholder: 'placeholder'
        });

    }

    componentDidUpdate(prevProps, prevState){
        if (!$('#tableSticky').hasClass('ui-sortable')) {

        }
    }

    componentWillUnmount() {
        $(window).off('scroll');

        $("#tableSticky").sortable('disable');

    }

    render() {
        return (
            <div>
                <table className="table table-striped" id="tableSticky" ref={el => this.el = el}>
                    <thead className="table-head" id="stickyHead" >
                    <tr >
                        {this.props.Headers.map(header => {
                            return <th className={"table-th " + header.style} key={header.key}>{header.value}</th>
                        })}
                    </tr>
                    </thead>
                    {
                        Object.keys(this.props.groupedQuestions).map( (key, index) => {
                            return (
                                <tbody id={this.props.groupedQuestions[key][0].groupId} key={this.props.groupedQuestions[key][0].groupId}>
                                {
                                    this.props.groupedQuestions[key].map((question, index) => {
                                        return (
                                            <TableRow
                                                handleSelectMultipleValue={this.props.handleSelectMultipleValue}
                                                handleSelectMultipleChange={this.props.handleSelectMultipleChange}
                                                changeRefSettingsInfoState={this.props.changeRefSettingsInfoState}
                                                infoState={this.props.infoState}
                                                key={index} Question={question}
                                                Trigger={this.props.Triggers[question.id]}
                                                ChangeQuestionTrigger={this.props.ChangeQuestionTrigger}
                                                HandleCheckedState={this.props.HandleCheckedState}
                                                HandleCheckBoxChange={this.props.HandleCheckBoxChange}
                                                CalculateChildQuestionOptionName={this.props.CalculateChildQuestionOptionName}
                                            />
                                        )
                                    })
                                }
                                </tbody>
                            )
                        })
                    }

                    {/*<tbody className="appFormRefSettings-tbody">*/}
                    {/*{*/}
                    {/*this.props.Questions.length > 0 ?*/}
                    {/*this.props.Questions.map((question, index) => {*/}
                    {/*return <TableRow*/}
                    {/*changeRefSettingsInfoState={this.props.changeRefSettingsInfoState}*/}
                    {/*infoState={this.props.infoState}*/}
                    {/*key={index} Question={question}*/}
                    {/*Trigger={this.props.Triggers[question.id]}*/}
                    {/*ChangeQuestionTrigger={this.props.ChangeQuestionTrigger}*/}
                    {/*HandleCheckedState={this.props.HandleCheckedState}*/}
                    {/*HandleCheckBoxChange={this.props.HandleCheckBoxChange}*/}
                    {/*CalculateChildQuestionOptionName={this.props.CalculateChildQuestionOptionName}*/}
                    {/*/>*/}
                    {/*})*/}
                    {/*:*/}
                    {/*null*/}
                    {/*}*/}

                    {/*</tbody>*/}
                </table>
            </div>
        )
    }
}
;

export default Table;